import i18n from "i18next";
import ICU from "i18next-icu";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
import detectLanguage from "./detectLanguage";
import { SUPPORTED_LOCALE_CODES } from "./supportedLocales";

const namespaces = [
  "mine",
  "toasts",
  "errors",
  "wallet",
  "dashboard",
  "craft",
  "market",
  "leaderboard",
  "settings",
  "claim",
  "economics",
  "referral",
  "staking",
  "swap",
  "navigation",
  "pulsar",
  "projectWallet"
];

const fallbackLng = "en";

if (!i18n.isInitialized) {
  i18n
    .use(ICU)
    .use(initReactI18next)
    .use(
      resourcesToBackend((lng, ns) => import(`../locales/${lng}/${ns}.json`))
    )
    .init({
      lng: detectLanguage(),
      fallbackLng,
      supportedLngs: SUPPORTED_LOCALE_CODES,
      defaultNS: "mine",
      ns: namespaces,
      interpolation: { escapeValue: false },
      returnNull: false,
      returnEmptyString: false
    });
}

export default i18n;
export { namespaces };
